import { OrganizationContent } from "../../content/organization/organizationsList";
import { Layout } from "../../layout/page";

export function Organization() {
  return (
    <Layout>
      <OrganizationContent />
    </Layout>
  );
}
